import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function IRCTIcon({ className }: IconProps) {
  return (
    <svg
      width="86"
      height="89"
      viewBox="0 0 86 89"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50.1962 73.4497H23.4277V84.2741H50.1962V73.4497Z"
        fill="#EAEEF9"
      />
      <path
        d="M69.5935 75.4751H4.00859C1.80386 75.4751 0 73.6523 0 71.4244V22.0507C0 19.8228 1.80386 18 4.00859 18H69.5935C71.7982 18 73.6021 19.8228 73.6021 22.0507V71.4244C73.6021 73.6523 71.7982 75.4751 69.5935 75.4751Z"
        fill="#EAEEF9"
      />
      <path
        d="M61.2425 89H12.3823C11.0906 89 10.0439 87.9423 10.0439 86.6371C10.0439 85.3319 11.0906 84.2742 12.3823 84.2742H61.2425C62.5342 84.2742 63.5808 85.3319 63.5808 86.6371C63.5808 87.9423 62.5342 89 61.2425 89Z"
        fill="#EAEEF9"
      />
      <path
        d="M66.5873 70.4118H7.0375C5.924 70.4118 5.0332 69.5116 5.0332 68.3864V25.1113C5.0332 23.9861 5.924 23.0859 7.0375 23.0859H66.6095C67.723 23.0859 68.6138 23.9861 68.6138 25.1113V68.3864C68.6138 69.5116 67.723 70.4118 66.6095 70.4118"
        fill="white"
      />
      <path
        d="M65.9188 47.4127H7.70521C7.32662 47.4127 7.03711 47.1202 7.03711 46.7376C7.03711 46.3551 7.32662 46.0625 7.70521 46.0625H65.9411C66.3196 46.0625 66.6091 46.3776 66.6091 46.7376C66.6091 47.0977 66.2974 47.4127 65.9411 47.4127"
        fill="#00C4B3"
      />
      <path
        d="M36.8126 68.7239C36.434 68.7239 36.1445 68.4314 36.1445 68.0488V25.4488C36.1445 25.0662 36.4563 24.7737 36.8126 24.7737C37.169 24.7737 37.4807 25.0887 37.4807 25.4488V68.0488C37.4807 68.4314 37.169 68.7239 36.8126 68.7239Z"
        fill="#00C4B3"
      />
      <path
        d="M24.4748 35.7781C23.4058 36.4982 22.1364 36.9258 20.7557 36.9258C19.3749 36.9258 18.1056 36.4982 17.0366 35.7781C14.431 37.0383 12.5158 39.5362 12.1372 42.5518C12.0704 43.1594 12.5381 43.6995 13.1394 43.6995H28.3943C28.9956 43.6995 29.4632 43.1594 29.3964 42.5518C29.0178 39.5362 27.1026 37.0383 24.497 35.7781H24.4748Z"
        fill="#00C4B3"
      />
      <path
        d="M25.4325 30.1746C25.4325 32.785 23.3391 34.9004 20.7558 34.9004C18.1725 34.9004 16.0791 32.785 16.0791 30.1746C16.0791 27.5641 18.1725 25.4487 20.7558 25.4487C23.3391 25.4487 25.4325 27.5641 25.4325 30.1746Z"
        fill="#00C4B3"
      />
      <path
        d="M52.6248 59.4771C48.1931 59.4771 44.5631 62.8076 44.0064 67.1284C43.9396 67.736 44.4072 68.2761 45.0085 68.2761H60.2634C60.8647 68.2761 61.3324 67.736 61.2656 67.1284C60.7088 62.8076 57.0565 59.4771 52.6471 59.4771"
        fill="#00416B"
      />
      <path
        d="M59.3284 54.7512C59.3284 58.4868 56.3219 61.5249 52.6251 61.5249C48.9283 61.5249 45.9219 58.4868 45.9219 54.7512C45.9219 51.0155 48.9283 48 52.6251 48C56.3219 48 59.3284 51.038 59.3284 54.7512Z"
        fill="white"
      />
      <path
        d="M57.3016 54.7512C57.3016 57.3617 55.2082 59.4771 52.6249 59.4771C50.0416 59.4771 47.9482 57.3617 47.9482 54.7512C47.9482 52.1408 50.0416 50.0254 52.6249 50.0254C55.2082 50.0254 57.3016 52.1408 57.3016 54.7512Z"
        fill="#00416B"
      />
      <path
        d="M24.4748 59.7898C23.4058 60.5099 22.1364 60.9375 20.7557 60.9375C19.3749 60.9375 18.1056 60.5099 17.0366 59.7898C14.431 61.05 12.5158 63.548 12.1372 66.5635C12.0704 67.1711 12.5381 67.7112 13.1394 67.7112H28.3943C28.9956 67.7112 29.4632 67.1711 29.3964 66.5635C29.0178 63.548 27.1026 61.05 24.497 59.7898H24.4748Z"
        fill="#00416B"
      />
      <path
        d="M25.4325 54.1863C25.4325 56.7967 23.3391 58.9121 20.7558 58.9121C18.1725 58.9121 16.0791 56.7967 16.0791 54.1863C16.0791 51.5758 18.1725 49.4604 20.7558 49.4604C23.3391 49.4604 25.4325 51.5758 25.4325 54.1863Z"
        fill="#00416B"
      />
      <path
        d="M82.5184 0H50.5833C49.158 0 48 1.17021 48 2.61046V37.4016C48 38.2792 49.0021 38.7743 49.6925 38.2117L56.908 32.3832H82.5184C83.9437 32.3832 85.1017 31.213 85.1017 29.7727V2.63296C85.1017 1.19271 83.9437 0.0225045 82.5184 0.0225045"
        fill="#00416B"
      />
      <path d="M69.4235 7.15625H65.0586V25.587H69.4235V7.15625Z" fill="white" />
      <path
        d="M76.3494 14.1775H58.1104V18.5883H76.3494V14.1775Z"
        fill="white"
      />
    </svg>
  );
}
